import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import {
  CRASHLYTICS_LOG,
  CRASHLYTICS_LOG_SUCCESS,
  CRASHLYTICS_LOG_ERROR,
  CRASHLYTICS_LOG_NONFATAL_ERROR,
  CRASHLYTICS_LOG_NONFATAL_ERROR_SUCCESS,
  CRASHLYTICS_LOG_NONFATAL_ERROR_ERROR,
  CRASHLYTICS_SET_USER_ID,
  CRASHLYTICS_SET_USER_ID_SUCCESS,
  CRASHLYTICS_SET_USER_ID_ERROR
} from "./messageTypes";

const crashlytics =
  window.cordova &&
  window.cordova.plugins &&
  window.cordova.plugins.firebase &&
  window.cordova.plugins.firebase.crashlytics;

if (crashlytics) {
  onMessageFromWebApp(CRASHLYTICS_LOG, async ({ message }) => {
    try {
      await crashlytics.log(message);
      sendMessageToWebApp(CRASHLYTICS_LOG_SUCCESS);
    } catch (error) {
      console.error(error);
      sendMessageToWebApp(CRASHLYTICS_LOG_ERROR, error);
    }
  });

  onMessageFromWebApp(CRASHLYTICS_LOG_NONFATAL_ERROR, async ({ message }) => {
    try {
      await crashlytics.log(message);
      sendMessageToWebApp(CRASHLYTICS_LOG_NONFATAL_ERROR_SUCCESS);
    } catch (error) {
      console.error(error);
      sendMessageToWebApp(CRASHLYTICS_LOG_NONFATAL_ERROR_ERROR, error);
    }
  });

  onMessageFromWebApp(CRASHLYTICS_SET_USER_ID, async ({ userId }) => {
    try {
      await crashlytics.log(userId);
      sendMessageToWebApp(CRASHLYTICS_SET_USER_ID_SUCCESS);
    } catch (error) {
      console.error(error);
      sendMessageToWebApp(CRASHLYTICS_SET_USER_ID_ERROR, error);
    }
  });
}
